/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface CancellationReason { 
    value: number;
    label: string;
}
export const CancellationReason_value_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CancellationReason_label_Validators: ValidatorFn[] =
    [  Validators.required, ];


